/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import {
    sharedAddressTitleStyle,
    sharedContentStyle,
} from "@monsma/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsShippingInformationExtension";
import { contentText, titleText } from "@monsma/App/WidgetExtensions/OrderDetails/OrderDateExtension";
import { css } from "styled-components";

savedOrderDetailsOrderInformationStyles.orderInformationGridContainer = {
    gap: 30,
    css: css`
        > div {
            width: calc(100% + 30px);
        }
    `,
};

savedOrderDetailsOrderInformationStyles.orderDateTitle = titleText;

savedOrderDetailsOrderInformationStyles.orderDateText = contentText;

savedOrderDetailsOrderInformationStyles.shippingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

savedOrderDetailsOrderInformationStyles.shippingAddressTitle = sharedAddressTitleStyle;

savedOrderDetailsOrderInformationStyles.shippingAddress = sharedContentStyle;

savedOrderDetailsOrderInformationStyles.billingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

savedOrderDetailsOrderInformationStyles.billingAddressTitle = sharedAddressTitleStyle;

savedOrderDetailsOrderInformationStyles.billingAddress = sharedContentStyle;
